import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcGenerateToken = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M1 6a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2v4.5a3 3 0 0 0-3 3 3 3 0 0 0-2.599 1.5H3a2 2 0 0 1-2-2V6Zm4.636 1.103a.75.75 0 1 0-1.272.795l.533.852H4a.75.75 0 1 0 0 1.5h.897l-.533.853a.75.75 0 0 0 1.272.795l.614-.983.614.983a.75.75 0 1 0 1.272-.795l-.533-.853H8.5a.75.75 0 1 0 0-1.5h-.897l.533-.852a.75.75 0 1 0-1.272-.795l-.614.982-.614-.982Zm5.966-.239a.75.75 0 0 1 1.034.239l.614.982.614-.982a.75.75 0 1 1 1.272.795l-.533.852h.897a.75.75 0 0 1 0 1.5h-.897l.533.853a.75.75 0 0 1-1.272.795l-.614-.983-.614.983a.75.75 0 0 1-1.272-.795l.533-.853H11a.75.75 0 1 1 0-1.5h.897l-.533-.852a.75.75 0 0 1 .238-1.034Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M20 12.5a1 1 0 0 0-1 1v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2a1 1 0 0 0-1-1Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcGenerateToken");

export { IcGenerateToken };
//# sourceMappingURL=ic-generate-token.js.map
